import { isFunction, isPlainObject } from 'lodash';
import isObject from 'lodash/isObject';

import { EmptyValue } from '@/common/types';

import { emptyValues } from './const';
import { getStatusMapping } from './getStatusMapping';

export function safeGet<T = unknown>(data: Record<string, unknown>, path: string) {
  if (!isObject(data) || !path) return;
  const paths: string[] = path.split('.');
  let res: Record<string, unknown> = data;
  while (paths.length) {
    res = res[paths.shift() as string] as Record<string, unknown>;
    if (res === undefined) return;
  }
  return res as T;
}

export function checkHasPermission(store: any, permission: string) {
  return safeGet<Function>(store, 'getters.hasPermission')?.(permission);
}

export const isValueEmpty = (v: unknown): v is EmptyValue => {
  return emptyValues.includes(v as never);
};

/**
 * Get select options
 * @param {Object | Array} source
 * @param {Object} options
 */
export function getSelectOptions(source: any, options: any = {}): any {
  const allOption = { label: 'All', value: '' };
  if (isPlainObject(source)) {
    const { dataPath = '', needAll = false, needTranslate = false } = options;

    const list: any = safeGet(source, dataPath) || {};
    const enumKey = dataPath.split('enums.systemEnums.').pop();
    const listOptions = Object.keys(list).map((key: any) => {
      if (enumKey && needTranslate) return { label: getStatusMapping(key, enumKey), value: list[key] };
      return { label: key, value: list[key] };
    });
    return needAll ? [allOption, ...listOptions] : listOptions;
  }
  if (Array.isArray(source)) {
    const { target = {}, labelKey = 'name', valueKey = 'id', disabledKey = 'disabled', labelCreator, needAll = false } = options;
    const { value, key } = target;
    const selectOptions = [];
    if (needAll) {
      selectOptions.push(allOption);
    }
    source.forEach(item => {
      let label;
      if (isFunction(labelCreator)) {
        label = labelCreator(item);
      } else {
        label = item[labelKey];
      }
      if (!value || item[key] === value) {
        selectOptions.push({ disabled: item[disabledKey], label, value: item[valueKey] });
      }
    });
    return selectOptions;
  }
};
